module.exports = __webpack_public_path__ + "static/babypaws-0703b3c2ebca7d168c3fa03df3beb8a3.png";